import { ChangeDetectionStrategy, Component, inject, input, InputSignal, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { BaseComponent } from '@/app/components/common/baseComponent/base.component';
import { PlycaUiFilterGenericDemoOneComponent } from '../filters/filter-generic/_demo/filter-one/filter-generic-demo-one.component';
import { PlycaUiFilterGenericDemoTwoComponent } from '../filters/filter-generic/_demo/filter-two/filter-generic-demo-two.component';
import { PlycaUiCollapsablePanelDemoComponent } from '../panels/collapsable-panel/_demo/collapsable-panel-demo.component';
import { PlycaUiBannerGenericDemoComponent } from '../banners/banner-generic/_demo/banner-generic-demo.component';
import { PlycaUiButtonGenericComponent } from './../../atoms/buttons/button-generic/button-generic.component';
import { PlycaUiScrollPanelDemoComponent } from '../panels/scroll-panel/_demo/scroll-panel-demo.component';
import { PlycaUiFormInputTextDemoComponent } from '../forms/input-text/_demo/input-text-demo.component';
import { FilterPanelDemoComponent } from '../filters/filter-panel/_demo/filter-panel-demo.component';
import { UiLibrarySectionComponent } from '../../../_demo/section/ui-library-section.component';
import { PlycaUiComparatorDemoComponent } from '../comparator/_demo/comparator-demo.component';
import { PlycaUiSplitterDemoComponent } from '../splitter/_demo/splitter-demo.component';
import { CheckboxDemoComponent } from '../forms/checkbox/_demo/checkbox-demo.component';
import { PlycaUiPanelDemoComponent } from '../panels/panel/_demo/panel-demo.component';
import { PlycaUiTreeDemoComponent } from '../tree/tree/_demo/tree-demo.component';
import { PlycaUiTableDemoComponent } from '../table/_demo/table-demo.component';
import { PlycaUiTabsDemoComponent } from '../tabs/_demo/tabs-demo.component';
import { OrganismsDictionary } from './_config/organisms-demo.dictionary';

@Component({
  selector: 'plyca-ui-organisms-demo',
  templateUrl: './organisms-demo.component.html',
  styleUrls: ['./organisms-demo.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UiLibrarySectionComponent,
    PlycaUiComparatorDemoComponent,
    FilterPanelDemoComponent,
    PlycaUiButtonGenericComponent,
    PlycaUiFormInputTextDemoComponent,
    PlycaUiCollapsablePanelDemoComponent,
    PlycaUiPanelDemoComponent,
    PlycaUiTableDemoComponent,
    PlycaUiTabsDemoComponent,
    PlycaUiTreeDemoComponent,
    CheckboxDemoComponent,
    PlycaUiSplitterDemoComponent,
    PlycaUiBannerGenericDemoComponent
  ]
})
export class PlycaUiDemoOrganismsComponent extends BaseComponent implements OnDestroy {
  public collapsed: InputSignal<boolean> = input.required<boolean>();
  public organismsDictionary = OrganismsDictionary;

  private readonly _dialogService = inject(DialogService);
  private _destroy$: Subject<void> = new Subject<void>();

  constructor() {
    super();
  }

  public openModalFilterGenericOne(): void {
    const config: DynamicDialogConfig = { header: 'Header Example', width: '45%', height: '65vh', style: { 'max-height': '80%' }, styleClass: 'searchStyle' };
    const ref = this._dialogService.open(PlycaUiFilterGenericDemoOneComponent, config);
    this.subscribe(ref?.onClose.pipe(takeUntil(this._destroy$)), (close: { status: string; data: any; search: Record<string, any> }) => {
      console.error(close);
    });
  }

  public openModalFilterGenericTwo(): void {
    const config: DynamicDialogConfig = { header: 'Header Example', width: '45%', height: '65vh', style: { 'max-height': '80%' }, styleClass: 'searchStyle' };
    const ref = this._dialogService.open(PlycaUiFilterGenericDemoTwoComponent, config);
    this.subscribe(ref?.onClose.pipe(takeUntil(this._destroy$)), (close: { status: string; data: any; search: Record<string, any> }) => {
      console.error(close);
    });
  }

  public openModalScrollPanel(): void {
    const config: DynamicDialogConfig = { header: 'Header Example', width: '45%', height: '65vh', style: { 'max-height': '80%' }, styleClass: 'searchStyle' };
    const ref = this._dialogService.open(PlycaUiScrollPanelDemoComponent, config);
    this.subscribe(ref?.onClose.pipe(takeUntil(this._destroy$)), (close: { status: string; data: any; search: Record<string, any> }) => {
      console.error(close);
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    super.ngOnDestroy();
  }
}
